import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { DialogActions } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import EnhancedTable from 'lib/designSystem/Table';
import KeyValueRow from 'lib/designSystem/KeyValueRow';
import AddTag from '../AddTag';
import TagSummary from '../TagSummary';
import DeleteCategory from '../DeleteCategory';
import EditCategory from '../EditCategory';

const CategorySummary = (props: any) => {
  const { open, onClose, category, setUp } = props;
  const [openAddTagModal, setOpenAddTagModal] = useState(false);
  const [selectedTag, setSelectedTag] = useState(null);
  const [openTagSummary, setOpenTagSummary] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [openEditCategory, setOpenEditCategory] = useState(false);

  const handleOpenAddTagModal = () => {
    setOpenAddTagModal(true);
  };

  const handleEditCategory = () => {
    setOpenEditCategory(true);
  };

  const handleDeleteCategory = () => {
    setOpenDeleteCategory(true);
  };

  const handleOpenTagSummary = (tagId: any) => {
    const tag = category.tags.find((x: any) => x.id === tagId);
    if (!tag) return alert('Ha ocurrido un error');
    setSelectedTag(tag);
    setOpenTagSummary(true);
  };

  return (
    <div>
      <Dialog open={open} maxWidth="md" fullWidth>
        <DialogTitle>Categoría</DialogTitle>
        <DialogContent>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
            }}
          >
            <KeyValueRow label="Nombre" value={category.name} />
            <KeyValueRow label="Descripción" value={category.description} />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography fontWeight={600}>Tags:</Typography>
              <CustomButton
                onClick={handleOpenAddTagModal}
                color="primary"
              >
                Crear Tag
              </CustomButton>
            </div>
            <EnhancedTable
              data={category.tags}
              dataHeaders={[
                { key: 'name', label: 'Tag' },
                { key: 'description', label: 'Descripción' },
                { key: 'color', label: 'Color', type: 'color' },
                { key: 'createdAt', label: 'Fecha de creación', type: 'date' },
              ]}
              rowsPerPageDefault={5}
              handleClickRow={handleOpenTagSummary}
            />
          </div>

        </DialogContent>
        <DialogActions>
          <CustomButton
            onClick={onClose}
            color="secondary"
          >
            Salir
          </CustomButton>
          <CustomButton
            onClick={handleDeleteCategory}
            color="error"
            disabled={category.tags.length > 0}
          >
            Eliminar
          </CustomButton>
          <CustomButton
            onClick={handleEditCategory}
            color="primary"
          >
            Editar
          </CustomButton>
        </DialogActions>
      </Dialog>
      {openAddTagModal && (
        <AddTag
          open={openAddTagModal}
          onClose={() => setOpenAddTagModal(false)}
          setUp={setUp}
          category={category}
        />
      )}
      {openTagSummary && (
        <TagSummary
          open={openTagSummary}
          onClose={() => setOpenTagSummary(false)}
          tag={selectedTag}
          setUp={setUp}
          category={category}
        />
      )}
      {openDeleteCategory && (
        <DeleteCategory
          open={openDeleteCategory}
          onClose={() => setOpenDeleteCategory(false)}
          category={category}
          setUp={setUp}
        />
      )}
      {openEditCategory && (
        <EditCategory
          open={openEditCategory}
          onClose={() => setOpenEditCategory(false)}
          category={category}
          setUp={setUp}
        />
      )}
    </div >
  );
};

export default CategorySummary;